import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(4),
    padding: theme.spacing(4, 0),
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  center: {
    textAlign: 'center',
  },
  subtitle: {
    paddingTop: theme.spacing(1),
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
  }
}));
